export const formatPrice = (number) => `${number.toFixed(2).replace('.', ',')}€`;
